export default "__VITE_ASSET__mvU9MHTz__"